import React, { FC } from 'react';

import { EvFlexRow, EvLoader } from '@evinced-private/ui-common';

interface IDeletingIndicatorProps {
	message: string;
}

export const DeletingIndicator: FC<IDeletingIndicatorProps> = ({ message }) => {
	return (
		<EvFlexRow align="CENTER">
			<EvLoader message={message} isSmall />
		</EvFlexRow>
	);
};
